import React, { useEffect, useState, useRef, useContext } from "react";
import AppContext from "./context";


function PlayButton({ isPlaying = false, handlePlay }) {
  return !isPlaying ? (
    <div className="PlayButton Play" onClick={handlePlay}>
     <span className="mck-play-icon bi bi-play-circle"></span>
    
    </div>
  ) : (
    <div className="PlayButton Pause" onClick={handlePlay}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        fill="currentColor"
        viewBox="0 0 16 16" 
      >
        <path d="M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5zm5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5z" />
      </svg>
    </div>
  );
}

export default function VideoPlayer({ id, sources, setRemainingTime }) {
  const [width, setWidth] = useState(0);
  const videoRef = useRef(null);

  const {currentPlayingId, setCurrentPlayingId} = useContext(AppContext);

  const handlePlay = (e) => {
    if(currentPlayingId.id === null) {
      videoRef.current.play();
      setCurrentPlayingId({id, isPlaying: true});
    }
    else if(currentPlayingId.id !== id) {
        videoRef.current.play();
        setCurrentPlayingId({id, isPlaying: true});
    } else {
      if(currentPlayingId.isPlaying) {
        videoRef.current.pause();
        setCurrentPlayingId({id, isPlaying: false});
      } else {
        videoRef.current.play();
        setCurrentPlayingId({id, isPlaying: true});
      }
    }
  };

  const handleTimeUpdate = (e) => {
    const video = videoRef.current;
    const widthRatio = video.currentTime / video.duration;
    setRemainingTime(video.duration - video.currentTime);
    setWidth(widthRatio * 100);
  };

  const handleEnded = (e) => {
    setCurrentPlayingId({...currentPlayingId, id, isPlaying: false});
  };
  
  const handleLoadedData = (e) => {
    if(e.target.readyState === 4) {
      setCurrentPlayingId({...currentPlayingId, haveEnoughData: true});
    }
  };

  useEffect(() => {
    if(currentPlayingId.id !== id) videoRef.current.pause();
  },[currentPlayingId]);
  
  useEffect(() => {
    const video = videoRef.current;
    video.addEventListener("timeupdate", handleTimeUpdate);
    video.addEventListener("loadeddata", handleLoadedData);
    video.addEventListener("ended", handleEnded, false);
    return () => {
      video.removeEventListener("loadeddata", handleLoadedData);
      video.removeEventListener("timeupdate", handleTimeUpdate);
      video.removeEventListener("ended", handleEnded);
    };
  }, []);

  return (
    <div className="VideoBox">
      <div className="TimingBar">
        <div
          className="timing"
          style={{
            width: `${width}%`,
          }}
        ></div>
      </div>
      <PlayButton isPlaying={currentPlayingId.id === id && currentPlayingId.isPlaying} handlePlay={handlePlay} />
       {sources.map(({ type, src, poster }, index) => (
         <video
            ref={videoRef}
            //preload="auto"
            loop=""
            muted=""
            playsInline=""
            webkit-playsinline="webkit-playsinline"
            className="Video"
            onClick={handlePlay}
            poster={poster}
            key={index}
          >
          <source key={index} type={type} src={src} />
          </video>
          ))}
    </div>
  );
}
